/**
 * Formats a file size in bytes to a human-readable string
 * @param bytes File size in bytes
 * @param decimals Number of decimal places to show
 * @returns Formatted string (e.g., "1.5 MB")
 */
export function formatFileSize(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
  }
  
  /**
   * Calculates percentage with defined decimal places
   * @param used Value used
   * @param total Total value
   * @param decimals Number of decimal places
   * @returns Formatted percentage
   */
  export function calculatePercentage(used: number, total: number, decimals: number = 1): number {
    if (total === 0) return 0;
    return parseFloat(((used / total) * 100).toFixed(decimals));
  }